
import { Table, Button, Popconfirm, Tag, Pagination, Tooltip } from "antd";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import moment from "moment";

const DataTable = ({
  data,
  meta,
  onDelete,
  onUpdate,
  onView,
  Onchange,
  expandedRowKeys,
  setExpandedRowKeys,
}) => {
  const columns = [
    // {
    //   title: "Sl",
    //   key: "index",
    //   width: "20px",
    //   render: (_, record, index) => index + 1,
    // },
    {
      title: "Purchase ID",
      dataIndex: "id",
      key: "purchase_id",
      width: 120,
      render: (text, record) => (
        <strong>{`PUR-${String(record.id).padStart(5, "0")}`}</strong>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 150,
      // ellipsis: true,
      render: (_, record) => (
        <Tooltip title={record?.description || "-"}>
          <span>{record?.description || "-"}</span>
        </Tooltip>
      ),
    },
    {
      title: "Total Amount",
      dataIndex: "total_amount",
      key: "total_amount",
      width: 120,
      render: (_, record) => record?.total_amount != null ? Number(record?.total_amount).toFixed(2) : "-",
    },
    {
      title: "Total Discount",
      dataIndex: "total_discount",
      key: "total_discount",
      width: 120,
      render: (_, record) => record?.total_discount != null ? Number(record?.total_discount).toFixed(2) : "-",
    },
    {
      title: "Outstanding",
      dataIndex: "outstanding",
      key: "outstanding",
      width: 120,
      render: (_, record) => record?.outstanding != null ? Number(record?.outstanding).toFixed(2) : "-",
    },
    {
      title: "Purchase Date",
      dataIndex: "payment_date",
      key: "payment_date",
      width: 120,
      render: (_, record) => record?.payment_date ? moment(record?.payment_date).format("DD-MM-YYYY") : "-",
    },
    {
      title: "Paid Amount",
      dataIndex: "paid_amount",
      key: "paid_amount",
      width: 120,
      render: (_,record) => record?.paid_amount != null ? Number(record?.paid_amount).toFixed(2) : "-",
    },
    {
      title: "Payment Status",
      dataIndex: "payment_status",
      key: "payment_status",
      width: 130,
      render: (payment_status) => {
        if (!payment_status) return <Tag color="default">-</Tag>;
        const tagColor = {
          paid: "success",
          partail: "warning",
          pending: "error",
        };
        return (
          <Tag color={tagColor[payment_status] ?? "default"}>
            {payment_status?.charAt(0).toUpperCase() + payment_status?.slice(1)}
          </Tag>
        );
      },
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      width: 120,
      render: (_, record) => record?.created_at ? moment(record?.created_at).format("DD-MM-YYYY") : "-",
    },
    {
      title: "Supplier Name",
      dataIndex: "supplierDetails",
      key: "supplierDetails",
      width: 150,
      ellipsis: true,
      render: (_, record) => record?.supplierDetails?.account_name || "",
    },
    {
      title: "Action",
      key: "action",
      width: 120,
      fixed: "right",
      render: (_, record) => (
        <div style={{ display: "flex", gap: 4, flexWrap: "nowrap" }}>
          <Tooltip title="View">
            <Button
              size="small"
              icon={<EyeOutlined />}
              onClick={() => onView(record)}
            />
          </Tooltip>
          <Tooltip title="Edit">
            <Button
              size="small"
              type="primary"
              icon={<EditOutlined />}
              onClick={() => onUpdate(record)}
            />
          </Tooltip>
          <Popconfirm
            title="Are you sure to delete this item?"
            onConfirm={() => onDelete(record)}
          >
            <Tooltip title="Delete">
              <Button
                size="small"
                danger
                icon={<DeleteOutlined />}
              />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
    },
  ];

  const detailColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "20%",
      render: (_, record) => record?.name || "",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: "20%",
      render: (_, record) => record?.description || "",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      width: "15%",
      render: (_, record) => record?.price != null ? Number(record?.price).toFixed(2) : "-",
    },

    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      width: "15%",
      render: (_, record) => record?.total != null ? Number(record?.total).toFixed(2) : "-",
    },
    {
      title: "Paid Amount",
      dataIndex: "paid_amount",
      key: "paid_amount",
      width: "15%",
      render: (_,record) => record?.paid_amount != null ? Number(record?.paid_amount).toFixed(2) : "-",
    },
   {
      title: "Paid Status",
      width: "15%",
      render: (_, record) => {
        const totalPaid = Number(record?.paid_amount) || 0;
        const totalAmount = Number(record?.total) || 0;

          if (totalPaid > 0 && totalPaid < totalAmount) {
          return <Tag color="orange">Partial</Tag>;
        } else if (totalPaid === totalAmount && totalAmount > 0) {
          return <Tag color="green">Paid</Tag>;
        }
        return <Tag color="red">Unpaid</Tag>; 
      },
    },
  ];

  const expandedRowRender = (record) => (
    <Table
      columns={detailColumns}
      dataSource={record?.purchaseDetails ?? []}
      pagination={false}
      rowKey="id"
      size="small"
    />
  );

  return (
    <div style={{ minHeight: "60vh" }}>
      <Table
        columns={columns}
        dataSource={data ?? []}
        rowKey="id"
        pagination={false}
        size="small"
        scroll={{ x: "max-content" }}
        expandable={{
          expandedRowRender,
          expandedRowKeys: expandedRowKeys ?? [],
          onExpand: (expanded, record) =>
            setExpandedRowKeys(
              expanded
                ? [...(expandedRowKeys ?? []), record?.id]
                : (expandedRowKeys ?? []).filter((key) => key !== record?.id)
            ),
        }}
      />
      <br />
      <div style={{ textAlign: "right" }}>
        <h6>
          Total: {meta?.itemCount || 0}{" "}
          {(meta?.itemCount || 0) === 1 ? "Purchase" : "Purchases"}
        </h6>
        <Pagination
          current={Number(meta?.page) || 1}
          total={Number(meta?.itemCount) || 0}
          pageSize={Number(meta?.take) || 10}
          onChange={Onchange}
          pageSizeOptions={[10, 20, 50]}
          showSizeChanger
        />
      </div>
    </div>
  );
};

export default DataTable;
